import { colors } from "constants/colors";
import { css, styled } from "styled-components";
import { StyledText } from "styles/Text";
import { ButtonType, MarginStyleType } from "types/Common";

interface Props {
  text: string; // 텍스트 타이틀
  type?: ButtonType;
  width?: string | number;
  height?: string | number;
  leftComponent?: React.ReactNode; // 좌측 컴포넌트
  isDisabled?: boolean; // 비활성화 여부
  contentAlign?: "center" | "flex-start"; // 버튼 컨텐츠 정렬
  borderColor?: string;
  bgColor?: string;
  fontSize?: number;
  fontWeight?: "normal" | "bold" | "300" | "400" | "500" | "700";
  txtColor?: string;
  onClick?: () => void;
}

const RectangleButton = ({
  text,
  type = "Normal",
  width,
  height = 44,
  leftComponent,
  isDisabled,
  contentAlign,
  borderColor,
  bgColor,
  fontSize,
  fontWeight = "400",
  txtColor,
  onClick,
  $marginTop,
  $marginBottom,
  $marginLeft,
  $marginRight,
}: Props & MarginStyleType) => {
  const _bgColor = bgColor
    ? bgColor
    : isDisabled || type === "Normal" || type === "Selected"
      ? colors.white
      : colors.mainOrange; // disabled 이거나 Normal, Selected인 경우에는 흰색,  그 외는 주황색
  const _borderColor = borderColor
    ? borderColor
    : isDisabled || type === "Normal"
      ? colors.lightGray2
      : type === "Selected"
        ? colors.mainOrange
        : undefined; // disabled or Normal: 회색, Selected: 주황색, 그외: 없음
  const textColor = txtColor
    ? txtColor
    : isDisabled || type === "Disabled"
      ? colors.lightGray2 // 회색
      : type === "Normal"
        ? colors.black // 검은색
        : type === "Focused"
          ? colors.white // 흰색
          : colors.mainOrange; // 주황색

  const getText = () => {
    switch (fontSize) {
      case 16:
        return (
          <StyledText.Body16 fontWeight={fontWeight} color={textColor}>
            {text}
          </StyledText.Body16>
        );
      default:
        return (
          <StyledText.Body15 fontWeight={fontWeight} color={textColor}>
            {text}
          </StyledText.Body15>
        );
    }
  };

  return (
    <StyledButton
      $type={type}
      onClick={() => {
        onClick && onClick();
      }}
      disabled={isDisabled}
      $bgColor={_bgColor}
      $borderColor={_borderColor}
      $widthValue={width}
      $heightValue={height}
      $marginTop={$marginTop}
      $marginBottom={$marginBottom}
      $marginLeft={$marginLeft}
      $marginRight={$marginRight}
    >
      {getText()}
    </StyledButton>
  );
};

export default RectangleButton;

interface OtherType {
  $type?: ButtonType;
  $widthValue?: string | number;
  $heightValue?: string | number;
  $bgColor?: string;
  $borderColor?: string;
}

const StyledButton = styled.button<OtherType & MarginStyleType>`
  display: block;
  /* flex-direction: row; */
  border-radius: 12px;
  padding: 0px 12px;
  align-items: center;
  background-color: ${({ $bgColor }) => $bgColor as string};
  ${({ $borderColor }) =>
    $borderColor &&
    css`
      border-width: 1px;
      border-color: ${$borderColor as string};
      border-style: solid;
    `};
  ${({ $widthValue }) =>
    $widthValue &&
    css`
      width: ${typeof $widthValue === "number"
        ? `${$widthValue}px`
        : typeof $widthValue === "string"
          ? `${$widthValue}`
          : "auto"};
    `};
  height: ${({ $heightValue }) =>
    typeof $heightValue === "number"
      ? `${$heightValue}px`
      : typeof $heightValue === "string"
        ? `${$heightValue}`
        : "auto"};

  ${({ $type, disabled }) =>
    !disabled &&
    $type === "Focused" && // Focused인 경우에는 그림자 생김
    css`
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16);
    `};

  ${({ $marginTop }) =>
    $marginTop &&
    css`
      margin-top: ${$marginTop}px;
    `}
  ${({ $marginBottom }) =>
    $marginBottom &&
    css`
      margin-bottom: ${$marginBottom}px;
    `}
  ${({ $marginLeft }) =>
    $marginLeft &&
    css`
      margin-left: ${$marginLeft}px;
    `}
  ${({ $marginRight }) =>
    $marginRight &&
    css`
      margin-right: ${$marginRight}px;
    `}
`;
